import React from "react";
import { createRoot } from "react-dom/client";
import JsonView from "@uiw/react-json-view";
import { githubDarkTheme } from "@uiw/react-json-view/githubDark";

function AdminJsonViewer({ value }: { value: unknown }) {
  return (
    <div className="max-h-96 overflow-auto rounded-lg border border-zinc-800 bg-[#0f172a] p-3 text-left">
      <JsonView
        value={value}
        collapsed={2}
        displayDataTypes={false}
        displayObjectSize
        enableClipboard
        shortenTextAfterLength={100}
        indentWidth={16}
        style={{
          ...githubDarkTheme,
          backgroundColor: "transparent",
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          fontSize: "12px",
          lineHeight: "1.55",
        }}
      />
    </div>
  );
}

document.querySelectorAll<HTMLElement>("[data-json-viewer]").forEach((element) => {
  const value = JSON.parse(element.dataset.json || "null");
  createRoot(element).render(<AdminJsonViewer value={value} />);
});
